import(/* webpackMode: "eager" */ "/opt/demo5-build/app/error.tsx");
